// extracted by mini-css-extract-plugin
export var cardContainer = "_pu-0";
export var cardHeader = "_pu-2";
export var collapsedState = "_pu-3";
export var dragHandle = "_pu-5";
export var dragHandleIcon = "_pu-6";
export var dragging = "_pu-1";
export var titleArea = "_pu-4";